<template>
  <div id="driversMap" />
</template>

<script>
/* eslint-disable no-undef */
import { onMounted, ref } from '@vue/composition-api'

export default {
  props: {
    locations: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, ctx) {
    const markerCases = state => {
      let link = null
      if (state === 'AVAILABLE') link = 'https://maps.google.com/mapfiles/ms/icons/green-dot.png'
      if (state === 'UNAVAILABLE') link = 'https://maps.google.com/mapfiles/ms/icons/red-dot.png'
      if (state === 'OCCUPIED') link = 'https://maps.google.com/mapfiles/ms/icons/orange-dot.png'
      return link
    }
    const map = ref(null)
    const currInfoWindow = ref(null)
    // const heatMapData = ref([])
    const initMap = () => {
      if (props.locations.length) {
        const center = {
          lat: +props.locations.at(0)?.location?.lat,
          lng: +props.locations.at(0)?.location?.lon,
        }
        map.value = new google.maps.Map(document.getElementById('driversMap'), {
          zoom: 10,
          center,
        })
      }
    }
    const createMarker = (driverExternalId, state, lat, lon) => {
      const marker = new google.maps.Marker({
        position: {
          lat: +lat,
          lng: +lon,
        },
        icon: markerCases(state),
        title: driverExternalId,
      })
      marker.addListener('click', async () => {
        let contentString = ''
        let driverID = null
        try {
          const result = await ctx.root.$store.dispatch('drivers/fetchDriverByExternalId', driverExternalId)
          const { data } = result.data
          const driverFullName = data.fullName
          driverID = data.id
          contentString = `<div id="content" style="width:200px">
            <p style="margin-top:5px;margin-bottom:5px">
              <strong>ID: </strong> <small>${driverExternalId}</small>  
            </p>
            <p style="margin-bottom:5px">
              <strong>Full Name: </strong> <small>${driverFullName}</small></p>
            <button id="driver-${driverExternalId}"
              style="background: #CE224D;
              border: 0;
              padding: 5px 8px;
              border-radius: 5px;
              color: white;
              width:100%"
            >Click here for details</button>
            </div>`
        } catch (error) {
          contentString = '<div id="content">An error occured.</div>'
        } finally {
          if (currInfoWindow.value) currInfoWindow.value.close()
          const infowindow = new google.maps.InfoWindow({
            content: contentString,
          })
          currInfoWindow.value = infowindow
          google.maps.event.addListener(infowindow, 'domready', () => {
            const clickButton = document.getElementById(`driver-${driverExternalId}`)
            if (clickButton) {
              clickButton.addEventListener('click', () => {
                // eslint-disable-next-line no-restricted-globals
                window.open(`${location.origin}/drivers/${driverID}?externalId=${driverExternalId}`)
              })
            }
          })
          infowindow.open({
            anchor: marker,
            map: map.value,
          })
        }
      })
      marker.setMap(map.value)
    }
    const setMarkers = () => {
      props.locations.forEach(loc => {
        if (loc.location?.lat && loc.location?.lon) {
          createMarker(loc.driver.id, loc.driver.status, loc.location.lat, loc.location.lon)
        }
      })
    }
    // const createHeatVisualization = () => {
    //   props.locations.forEach(loc => {
    //     if (loc.location?.lat && loc.location?.lon) {
    //       const latLng = new google.maps.LatLng(+loc.location.lat, +loc.location.lon)
    //       heatMapData.value.push(latLng)
    //     }
    //   })
    //   const heatmap = new google.maps.visualization.HeatmapLayer({
    //     data: heatMapData.value,
    //     maxIntensity: 1,
    //     gradient: [
    //       'rgba(0, 255, 255, 0)',
    //       'rgba(0, 255, 255, 1)',
    //       'rgba(0, 191, 255, 1)',
    //       'rgba(0, 127, 255, 1)',
    //       'rgba(0, 63, 255, 1)',
    //       'rgba(0, 0, 255, 1)',
    //       'rgba(0, 0, 223, 1)',
    //       'rgba(0, 0, 191, 1)',
    //       'rgba(0, 0, 159, 1)',
    //       'rgba(0, 0, 127, 1)',
    //       'rgba(63, 0, 91, 1)',
    //       'rgba(127, 0, 63, 1)',
    //       'rgba(191, 0, 31, 1)',
    //       'rgba(255, 0, 0, 1)',
    //     ],
    //   })
    //   heatmap.setMap(map.value)
    // }
    onMounted(() => {
      initMap()
      // createHeatVisualization()
      setMarkers()
    })
  },
}
</script>

<style>
#driversMap {
  width: 100%;
  height: 600px;
}
</style>
